import { DetailList } from 'components/site/modals/DetailListModal/DetailList';
import { SidebarDefaultFooter } from 'components/site/modals/SidebarModalWrapper/SidebarDefaultFooter';
import { SidebarModalWrapper } from 'components/site/modals/SidebarModalWrapper/SidebarModalWrapper';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';
import { Localization } from 'static/localization/localization';

interface Props {
    storyIds: string[];
}

export const DetailListModal = (props: Props): JSX.Element => {
    const ctxModal = useContext(CtxModal);

    const onClose = () => {
        ctxModal.setDetailListModal(null);
    };

    const content = <DetailList storyIds={props.storyIds} />;

    const footer = (
        <SidebarDefaultFooter
            buttons={[
                {
                    iconName: 'xmark',
                    text: Localization.CLOSE,
                    onClick: onClose
                }
            ]}
        />
    );

    return (
        <SidebarModalWrapper
            content={content}
            footer={footer}
            onClose={onClose}
            background={'#f1f1f1'}
        />
    );
};
